import eventBus from "../../utils/eventBus";
const AniTypeMap = {
  transformKeys:['x','y','s','r'],
  topKeys: ['f','h'],
  y(progress, [start, end]) {
    let value = (1 - progress) * Math.abs (end - start);
    return "translateY(" + value + "px)";
  },
  x(progress, [start]) {
    let value = (1-progress) * start;
    return "translateX(" + value + "px)";
  },
  s(progress, [start, end]) {
    let value;
    if (end - start > 0) {
      value = 1 + (progress *  (end - start));
    } else {
      value = 1 + ((1 - progress) *  Math.abs(end - start));
    }
    return `scale(${value},${value})`;
  },
  o(progress, [start, end]) {
    let value;
    if (end - start > 0) {
      value = (progress) * (end - start);
    } else {
      value = (1-progress) * (start);
    }
    return `opacity:${value};`;
  },
  r(progress, [start, end]){
    let value = (progress) * end - start;
    return `rotate(${value}deg)`;
  },
  f(progress, [start, end]){
    if (progress == 0) {
      return 'position:absolute;top:0';
    }
    if (progress > 0 && progress < 1) {
      return 'position:fixed;top:48px;'
    }
    if (progress >= 1) {
      return ';bottom: 0;'
    }
    let value = (progress) * end - start;
    return `rotate(${value}deg)`;
  },
  h(progress, [start]){
    let height = this.elHeight;
    let nowProgress = 1 - progress;
    eventBus.emitAsync('changePlay', height);
    return `height:${nowProgress*height}px;z-index:${start};`;
  },
};
class AttrRender {
  constructor({ start, end, change, type, key='', endkey='' }, {startTop, range, screenHeight, el}) {
    this.el = el;
    this.key = key;
    this.endkey = endkey;
    this.type = type;
    this.start = (startTop - screenHeight) + (start/100) * range;
    this.end = (startTop - screenHeight) + (end/100) * range;
    this.headerTop = 48;
    if (type === 'h') {
      this.elHeight = el.parentNode.clientHeight;
      this.start = startTop + (start/100) * range;
      this.end = startTop + (end/100) * range;
    }
    if (type === 'f') {
      this.elHeight = el.clientHeight;
      this.start = startTop;
      this.end = startTop + (range - this.elHeight);
    }
    this.change = change;
    this._render = AniTypeMap[type];
  }
  render(attrProgress, change) {
    return this.key + this._render(attrProgress, change) + this.endkey;
  }
  update(progress) {
    progress += this.headerTop;
    if (progress <= this.start) return this.render(0, this.change);
    if (progress >= this.end) return this.render(1, this.change);
    let attrProgress = (progress - this.start) / (this.end - this.start);
    return this.render(attrProgress, this.change);
  }
}
class AniItem {
  renders = null;
  constructor(el, {startTop, endTop, range, screenHeight}) {
    this.el = el;
    this.screenHeight = screenHeight;
    this.style = this.el.style;
    this.startTop = startTop;
    this.range= range;
    this.endTop = endTop;
    this.cssCatch = '';
    this.parseAttr();
  }
  parseAttr() {
    let aniData = this.el.dataset.animate;
    if (aniData) {
      let aniJson = JSON.parse(aniData);
      let keys = AniTypeMap.transformKeys;
      let arrT = [];
      let arrO = [];
      aniJson.forEach(v => {
        if(keys.includes(v.type)) {
          v.endkey = ' ';
          arrT.push(v);
        } else {
          arrO.push(v);
        }
      })
      if (arrT.length) {
        arrT[0].key = 'transform:';
        arrT[arrT.length-1].endkey = ';';
      }
      let allArr = [...arrT,...arrO];
      this.renders = allArr.map(v => {
        return new AttrRender({...v}, this)
      });
    }
  }
  update(progress) {
    let cssText = '';
    this.renders.forEach(v => {
      cssText += v.update(progress);
    })
    cssText && (this.style.cssText = cssText);
  }
}
class AniGroup {
  items = [];
  active = false;
  startTop = 0;
  endTop = 0;
  constructor(el, screenHeight) {
    this.screenHeight = screenHeight;
    this.el = el;
    this.startTop = el.offsetTop;
    this.range = el.clientHeight;
    this.endTop = this.startTop + this.range;
    // this.checkTop = (this.el.dataset.check/100)*this.screenHeight;
    // this.checkStart = this.startTop-this.screenHeight - this.screenHeight/2;
    // this.checkEnd = this.startTop + this.range + this.screenHeight/2;
    this.createAniItems();
  }
  createAniItems() {
    let els = Array.from(this.el.querySelectorAll("[data-animate*=type]"));
    els.forEach((v) => {
      this.items.push(new AniItem(v, this));
    });
  }
  check(top) {
    return top > this.startTop && top < this.endTop;
  }
  start() {
    this.active = true;
  }
  end() {
    this.active = false;
  }
  init(scrollTop) {
    this.update(scrollTop, true);
  }
  update(scrollTop) {
    // let trueTop = scrollTop;
    // if (!noCheck) {
    //   if (this.checkTop) {
    //     trueTop -= this.checkTop;
    //   }
    //   if (trueTop < this.checkStart || trueTop > this.checkEnd) {
    //     return;
    //   }
    // }
    let progress = scrollTop;
    this.items.forEach(v => v.update(progress));
    return true;
  }
}
class Scheduler {
  activeGroup = null;
  groups = [];
  constructor(screenHeight) {
    this.screenHeight = screenHeight;
    this.createAniGroups();
  }
  createAniGroups() {
    let els = Array.from(document.querySelectorAll("[data-ani=aniGroup]"));
    els.forEach((v) => {
      this.groups.push(new AniGroup(v, this.screenHeight));
    });
  }
  findActiveGroup(top) {
    this.activeGroup = this.groups.find((v) => v.check(top));
  }
  init(top) {
    this.groups.forEach(v => v.init(top));
  }
  update(top) {
    this.groups.forEach(v => v.update(top));
    // !this.activeGroup && this.findActiveGroup(top);
    // if (this.activeGroup) {
    //   if (!this.activeGroup.update(top)) {
    //     this.activeGroup = this.findActiveGroup(top);
    //   }
    // }
  }
}
export default Scheduler;
